'use client';

import { Box, Container, Flex, Link, Text, useSlotRecipe, VStack } from '@chakra-ui/react';

import { dateHelpers } from '@nocowanie/core/helpers';

import { AppPromotionLinks } from '@app/components/molecules/app-promotion-links';
import { SocialMedia } from '@app/components/molecules/social-media';
import { FooterProps } from '@app/components/organisms/footer/footer.props';
import menuLinks from '@app/components/organisms/footer/menu-links.json';
import { staticLinks } from '@app/components/organisms/footer/static-links-data';

export const Footer = ({ ...rest }: FooterProps) => {
    const recipe = useSlotRecipe({ key: 'footer' });
    const styles = recipe();

    return (
        <Box as={'footer'} css={styles.wrapper} {...rest}>
            <Container css={styles.container}>
                <VStack hideFrom="md" alignItems={'flex-start'} mb={9} gap={7}>
                    <SocialMedia />
                    <AppPromotionLinks />
                </VStack>
                <Flex gap={2}>
                    <Box
                        w="full"
                        css={{
                            columnCount: { base: 1, md: 3 },
                        }}
                    >
                        {menuLinks.map((link, index) => (
                            <VStack key={index} mb={4} alignItems={'flex-start'}>
                                <Link
                                    href={link.url}
                                    target={link.target ?? '_self'}
                                    variant={'plain'}
                                    css={styles.link}
                                >
                                    {link.label}
                                </Link>
                            </VStack>
                        ))}
                    </Box>
                    <VStack minW={'285px'} alignItems={'flex-start'} hideBelow="md" gap={8}>
                        <SocialMedia />
                        <AppPromotionLinks />
                    </VStack>
                </Flex>
                <Flex direction={'column'} justifyContent={'center'} fontSize={'sm'} mt={4} gap={8}>
                    <Flex flexWrap={'wrap'} gap={1}>
                        {staticLinks.map((link, index) => (
                            <Box key={index}>
                                <Link href={link.url} css={styles.link} variant={'plain'}>
                                    {link.label}
                                </Link>
                                {index < staticLinks.length - 1 ? ',' : null}
                            </Box>
                        ))}
                    </Flex>
                    <Text>
                        Copyright 2005-{dateHelpers.format(new Date(), 'yyyy')}{' '}
                        <Box as="br" hideFrom={'md'} />
                        by NOCOWANIE.PL Sp. z o.o.
                    </Text>
                </Flex>
            </Container>
        </Box>
    );
};
